import React, { useEffect, useState } from "react";
import {
  Airplay,
  ChevronLeft,
  Eye,
  Feather,
  Menu,
  Play,
  Target,
} from "react-feather";
import { Link, useLocation } from "react-router-dom";
import {
  getAllBillsPaginated,
  getBillById,
  saveBill,
} from "../Service/BillService";
import { getAllVehicles } from "../Service/VehicleService";
import { getAllVendors } from "../Service/VendorService";
import { useToast } from "../Components/toast/ToastProvider";
import "../Style/home.css";
import Sidebar from "./Sidebar";
import Footer from "../Components/Footer";
import { formatDate } from "../Config/function";

const BillViewPage = ({ handleLogout }) => {
  const [showSideBar, setShowSideBar] = useState(false);
  const toast = useToast();
  const [vehicles, setVehicles] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [activeTab, setActiveTab] = useState("new");
  const [currentPage, setCurrentPage] = useState(1);
  const [paginatedTrips, setPaginatedTrips] = useState([]);
  const [trips, setTrips] = useState([]);
  const [updatingId, setUpdatingId] = useState(null);
  const location = useLocation();
  const currentPath = location.pathname;
  const PAGE_SIZE = 10;

  useEffect(() => {
    fetchBillTrips();
    fetchVehicles();
    fetchVendors();
  }, []);

  useEffect(() => {
    paginateTrips();
  }, [trips, activeTab, currentPage]);

  const paginateTrips = () => {
    const filtered = trips.filter((t) => t.status === activeTab);
    const start = (currentPage - 1) * PAGE_SIZE;
    setPaginatedTrips(filtered.slice(start, start + PAGE_SIZE));
  };

  const totalPages = Math.ceil(
    trips.filter((t) => t.status === activeTab).length / PAGE_SIZE
  );

  const fetchBillTrips = async (page, limit, activeTab) => {
    try {
      const res = await getAllBillsPaginated(page, limit, activeTab);

      setTrips(res.data || []);
    } catch (err) {
      toast(err.message || "Failed to fethc bills", "ERROR");
    }
  };

  const fetchVehicles = async () => {
    try {
      const res = await getAllVehicles();
      setVehicles(res.data || []);
    } catch (err) {
      toast(err.message || "Failed to fetch vendors", "ERROR");
    }
  };

  const fetchVendors = async () => {
    try {
      const res = await getAllVendors();
      setVendors(res.data || []);
    } catch (err) {
      toast(err.message || "Failed to Fetch vendors", "ERROR");
    }
  };

  const updateBillStatus = async (bill, nextStatus) => {
    const res = await getBillById(bill.id);
    const trips = res?.data?.trips || [];

    const payload = {
      ...bill,
      status: nextStatus,
      trips: trips,
    };

    await saveBill(payload);
  };

  const handleToggleStatus = async (bill) => {
    const nextStatus = bill.status === "process" ? "paid" : "process";

    try {
      setUpdatingId(bill.id);

      await updateBillStatus(bill, nextStatus);

      toast(`Bill moved to ${nextStatus.toUpperCase()}`, "SUCCESS");

      fetchBillTrips();
    } catch (err) {
      toast(err.message || "Failed to update bill status", "ERROR");
    } finally {
      setUpdatingId(null);
    }
  };

  const renderStatusBadge = (status) => {
    const map = {
      new: "secondary",
      process: "warning",
      paid: "success",
    };
    return <span className={`badge bg-${map[status]}`}>{status}</span>;
  };

  return (
    <div className="fixed-bottom-bar " style={{ backgroundColor: " #F0F8FF" }}>
      <div className="osahan-trending">
        {/* Header */}
        <div className="bg-primary border-bottom p-3">
          <div className=" d-flex align-items-center justify-content-between">
            <Link to="/" className="text-white font-weight-bold">
              <ChevronLeft /> Back
            </Link>
            <Link className="toggle">
              <span
                className="toggle"
                onClick={() => setShowSideBar(true)}
                style={{ cursor: "pointer" }}
              >
                <Menu size={30} color="white" />
              </span>
            </Link>
          </div>
          <h2 className="font-weight-bold pt-3 m-0 text-white">Billing view</h2>
        </div>

        <div className="bill-tabs">
          {["new", "process", "paid"].map((tab) => (
            <div
              key={tab}
              className={`bill-tab ${activeTab === tab ? "active" : ""}`}
              onClick={() => {
                setActiveTab(tab);
                setCurrentPage(1);
              }}
            >
              {tab.toUpperCase()}
            </div>
          ))}
        </div>

        {/* Trending Cards */}
        <div className="row justify-content-center p-2">
          {paginatedTrips.map((bill) => {
            const vendorName = vendors.find((v) => v.id === bill.vendor_id);
            const vehicleNo = vehicles.find((v) => v.id === bill.vehicle_id);

            return (
              <div
                className="col-12 d-flex justify-content-center mb-3"
                key={bill.id}
              >
                <div className=" mt-3 bill-card">
                  <div className="card-body">
                    {/* HEADER */}
                    {/* <div className="bill-card-header ">
                        <span className="bill-no">{bill.bill_no}</span>
                       <span className={`status-pill ${bill.status}`}>
                       {bill.status}
                       </span>
                       </div> */}

                    {/* COMMON */}
                    <div className="bill-info">
                      <div className="info-row">
                        <span className="label"> Bill Date:</span>
                        <span className="value">{formatDate(bill.date)}</span>
                      </div>
                      <div className="info-row">
                        <span className="label">Vendor</span>
                        <span className="value">{vendorName?.name}</span>
                      </div>

                      <div className="info-row">
                        <span className="label">Vehicle</span>
                        <span className="value">
                          {vehicleNo?.vehicle_number}
                        </span>
                      </div>

                      <div className="info-row">
                        <span className="label">Trips</span>
                        <span className="value">{bill.trip_count}</span>
                      </div>

                      <div className="info-row total-row">
                        <span className="label">Total Amount</span>
                        <span className="amount">
                          ₹ {bill.total_amount.toFixed(2)}
                        </span>
                      </div>
                    </div>

                    {/* PROCESS TAB */}
                    {activeTab === "process" && (
                      <>
                        <div className="deduction-box">
                          <div className="info-row">
                            <span className="label">Nor Deduction</span>
                            <span className="value">
                              ₹{" "}
                              {bill.nor_advance_deduction?.toFixed(2) || "0.00"}
                            </span>
                          </div>

                          <div className="info-row">
                            <span className="label">Rec Deduction</span>
                            <span className="value">
                              ₹{" "}
                              {bill.res_advance_deduction?.toFixed(2) || "0.00"}
                            </span>
                          </div>

                          <div className="info-row payable-row">
                            <span className="label">Payable Amount</span>
                            <span className="payable">
                              ₹ {bill.payable_amount?.toFixed(2) || "0.00"}
                            </span>
                          </div>
                        </div>

                        <button
                          className="btn btn-sm btn-success mt-2 d-flex justify-content-center"
                          disabled={updatingId === bill.id}
                          onClick={() => handleToggleStatus(bill)}
                        >
                          {updatingId === bill.id
                            ? "Updating..."
                            : "Mark as PAID"}
                        </button>
                      </>
                    )}

                    {/* PAID TAB */}
                    {activeTab === "paid" && (
                      <>
                        <div className="deduction-box">
                          <div className="info-row">
                            <span className="label">Nor Deduction</span>
                            <span className="value">
                              ₹{" "}
                              {bill.nor_advance_deduction?.toFixed(2) || "0.00"}
                            </span>
                          </div>

                          <div className="info-row">
                            <span className="label">Rec Deduction</span>
                            <span className="value">
                              ₹{" "}
                              {bill.res_advance_deduction?.toFixed(2) || "0.00"}
                            </span>
                          </div>

                          <div className="info-row payable-row">
                            <span className="label">Payable Amount</span>
                            <span className="payable">
                              ₹ {bill.payable_amount?.toFixed(2) || "0.00"}
                            </span>
                          </div>
                        </div>

                        <button
                          className="btn btn-sm btn-success mt-2"
                          disabled={updatingId === bill.id}
                          onClick={() => handleToggleStatus(bill)}
                        >
                          {updatingId === bill.id
                            ? "Updating..."
                            : "Move to process"}
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {/* {totalPages > 1 && ( */}
        <div className="d-flex justify-content-center mt-3">
          <ul className="pagination pagination-sm">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                ‹
              </button>
            </li>

            {[...Array(totalPages)].map((_, i) => (
              <li
                key={i}
                className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </button>
              </li>
            ))}

            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                ›
              </button>
            </li>
          </ul>
        </div>
        {/* )} */}

        {/* Sidebar */}
        <Sidebar
          showSideBar={showSideBar}
          setShowSideBar={setShowSideBar}
          onLogout={handleLogout}
        />

        {/* Footer */}
       <Footer />
      </div>
    </div>
  );
};

export default BillViewPage;
